//- Absence Request Includes
export default [
    'hr_absence_request_type',
    'hr_absence_request_status',
    'hr_employee',
    // 'g_user',
]
